import { LoginInfo } from "@/models/persistentEntryPoint/LoginInfo"

const LOGIN_INFO_KEY = "oplux"

export function getLoginInfo() {
  const loginInfo = localStorage.getItem(LOGIN_INFO_KEY)

  return loginInfo ? (JSON.parse(loginInfo) as LoginInfo) : null
}
